// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scopes-item_scopesListItem__3B3kf {\n  display: flex;\n  max-width: 420px;\n  width: 100%;\n}\n\n.scopes-item_readCheckboxCell__3iE2e {\n  width: 70px;\n  margin-bottom: 10px;\n}\n\n.scopes-item_writeCheckboxCell__2-F7U {\n  flex-grow: 2;\n}\n\n.scopes-item_scopesCell__1vSx9 {\n  width: 280px;\n  margin-left: -30px;\n}\n\n.scopes-item_margin-l5__16tnJ {\n  margin-left: 10px;\n}", ""]);
// Exports
exports.locals = {
	"scopesListItem": "scopes-item_scopesListItem__3B3kf",
	"readCheckboxCell": "scopes-item_readCheckboxCell__3iE2e",
	"writeCheckboxCell": "scopes-item_writeCheckboxCell__2-F7U",
	"scopesCell": "scopes-item_scopesCell__1vSx9",
	"margin-l5": "scopes-item_margin-l5__16tnJ"
};
module.exports = exports;
